{
  "R": [0, 0, 0],
  "G": [0, 128, 255],
  "B": [0, 0, 0],
  "A": [0, 64, 128],
  "I": [0, 128, 255]
}
